export const setFieldLabel = (field, renderData, value, t) => {
  const label = t(field.label);
  return renderData?.rules && field?.name in renderData.rules && (value === '' || value === null) 
    ? `${label} *` 
    : label;
};
